import { FC, useCallback } from 'react';
import ViewColumnIcon from '@mui/icons-material/ViewColumn';
import { IconButton } from '@mui/material';
import { useAtomValue } from 'jotai';
import * as Dropdown from '../../../../../components/DropdownMenu';
import { MenuStateProvider, useMenuState } from '../../../../../components/DropdownMenu/MenuContext';
import { PermissionService } from '../../../../../services/PermissionService';
import { useColumnSelector } from '../../../providers/ColumnSelectorProvider';
import { pfGridApiAtom } from '../PfState';
import { ColumnsSettingsContent } from './ColumnsSettingsContent';
import { setColumnOrderAndVisibility } from './setColumnOrderAndVisibility';

interface IColumnsSettingsDropdownProps {
  /** The toggler's size; a 32px toolbar row asks for `small`. */
  size?: 'small' | 'medium' | 'large';
}

export const ColumnsSettingsDropdown: FC<IColumnsSettingsDropdownProps> = ({ size = 'large' }) => {
  const gridApi = useAtomValue(pfGridApiAtom);
  const { activeOrder } = useColumnSelector();
  const isAuditView = PermissionService.get().isAuditor();

  const applyChanges = useCallback(() => {
    setColumnOrderAndVisibility(activeOrder, gridApi);
  }, [activeOrder, gridApi]);
  // Hide column settings in audit view
  if (isAuditView) {
    return null;
  }

  return (
    <MenuStateProvider onCloseCallback={applyChanges}>
      <ColumnMenu size={size} />
    </MenuStateProvider>
  );
};

const ColumnMenu: FC<Required<IColumnsSettingsDropdownProps>> = ({ size }) => {
  const { open } = useMenuState();

  const Content = !open ? () => null : ColumnsSettingsContent;
  return (
    <Dropdown.Menu
      togglerContent={
        <IconButton title={'Manage columns'} size={size}>
          <ViewColumnIcon color='secondary' />
        </IconButton>
      }
    >
      <Content />
    </Dropdown.Menu>
  );
};
